import script from "./TabByCompany.vue?vue&type=script&lang=ts&setup=true"
export * from "./TabByCompany.vue?vue&type=script&lang=ts&setup=true"

import "./TabByCompany.vue?vue&type=style&index=0&id=4f4a7f75&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f4a7f75"]])

export default __exports__